import { render, staticRenderFns } from "./layananPendidikan.vue?vue&type=template&id=552a53ca&"
import script from "./layananPendidikan.vue?vue&type=script&lang=js&"
export * from "./layananPendidikan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtn,QTooltip,QSeparator,QBtnGroup,QPagination,QDialog,QInput,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QBtn,QTooltip,QSeparator,QBtnGroup,QPagination,QDialog,QInput,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
